export default __webpack_public_path__ + "static/media/logo-wls-horizontal.e332934f.cdf0df1e.png";